import React from 'react';
import '../../styles/home.css';

// Prova social — tiles EXATOS da página modelo
export const SocialProof: React.FC = () => {
  return (
    <section className="prova">
      <div><b>+140 mil</b><span>mapas interpretados</span></div>
      <div><b>+12 mil</b><span>sinastrias consultadas</span></div>
      <div><b>4,9 ★</b><span>avaliação média</span></div>
      <div><b>24h</b><span>a Stela está sempre aí</span></div>
    </section>
  );
};
